/* ==========================================================================
   MUQ OFFICIAL — Cart Drawer JavaScript
   Stok limiti kontrollü final sürüm.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__edmeCartDrawerInitialized) return;
  window.__edmeCartDrawerInitialized = true;

  const CART_DRAWER_SELECTOR = '[data-cart-drawer]';
  const OVERLAY_SELECTOR = '[data-overlay]';

  let cartDrawer = document.querySelector(CART_DRAWER_SELECTOR);
  const overlay = document.querySelector(OVERLAY_SELECTOR);

  if (!cartDrawer) return;

  let isUpdating = false;
  let qtyInputTimer = null;

  const getDrawer = () => {
    cartDrawer = document.querySelector(CART_DRAWER_SELECTOR);
    return cartDrawer;
  };

  const measureScrollbarWidth = () => {
    const outer = document.createElement('div');
    outer.style.cssText =
      'visibility:hidden;overflow:scroll;width:100px;height:100px;position:absolute;top:-9999px;';

    document.body.appendChild(outer);

    const inner = document.createElement('div');
    inner.style.width = '100%';
    outer.appendChild(inner);

    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    document.body.removeChild(outer);

    return scrollbarWidth;
  };

  const setScrollbarWidth = () => {
    document.documentElement.style.setProperty('--scrollbar-width', `${measureScrollbarWidth()}px`);
  };

  const findCartItemByKey = (key) => {
    const drawer = getDrawer();
    if (!drawer || !key) return null;

    const items = drawer.querySelectorAll('[data-cart-item]');

    return Array.from(items).find((item) => item.dataset.lineKey === key) || null;
  };

  const findQtyInputByKey = (key) => {
    const drawer = getDrawer();
    if (!drawer || !key) return null;

    const inputs = drawer.querySelectorAll('[data-qty-input]');

    return Array.from(inputs).find((input) => input.dataset.qtyInput === key) || null;
  };

  const getMaxQtyByKey = (key) => {
    const input = findQtyInputByKey(key);
    const item = findCartItemByKey(key);

    const rawMax =
      input?.dataset.maxQty ||
      input?.getAttribute('max') ||
      item?.dataset.maxQty ||
      '';

    if (rawMax === '') return null;

    const max = parseInt(rawMax, 10);

    if (Number.isNaN(max) || max < 0) return null;

    return max;
  };

  const showStockWarning = (maxQty) => {
    const message =
      maxQty > 0
        ? `Bu ürün için sepete en fazla ${maxQty} adet ekleyebilirsiniz.`
        : 'Bu ürün için yeterli stok bulunmuyor.';

    alert(message);
  };

  const setDrawerLoading = (loading) => {
    const drawer = getDrawer();
    if (!drawer) return;

    drawer.classList.toggle('is-updating', loading);

    drawer
      .querySelectorAll('[data-qty-increase], [data-qty-decrease], [data-cart-remove], [data-qty-input]')
      .forEach((el) => {
        if ('disabled' in el) {
          el.disabled = loading;
        }
      });
  };

  const closeOtherPanels = () => {
    const mobileMenu = document.querySelector('[data-mobile-menu]');
    const searchOverlay = document.querySelector('[data-search-overlay]');

    mobileMenu?.classList.remove('is-open');
    mobileMenu?.setAttribute('aria-hidden', 'true');

    searchOverlay?.classList.remove('is-open');
    searchOverlay?.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('menu-open', 'search-open');
    document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');

    if (window.__edmeCloseSearch && typeof window.__edmeCloseSearch === 'function') {
      window.__edmeCloseSearch();
    }
  };

  const openCartDrawer = () => {
    const drawer = getDrawer();
    if (!drawer) return;

    setScrollbarWidth();
    closeOtherPanels();

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');

    overlay?.classList.add('is-active');
    document.body.classList.add('cart-open');
  };

  const closeCartDrawer = () => {
    const drawer = getDrawer();

    drawer?.classList.remove('is-open');
    drawer?.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('cart-open');

    if (
      !document.body.classList.contains('menu-open') &&
      !document.body.classList.contains('search-open')
    ) {
      overlay?.classList.remove('is-active');
    }
  };

  window.__edmeOpenCart = openCartDrawer;
  window.__edmeCloseCart = closeCartDrawer;

  const updateCartHeaderCount = async () => {
    const cartRes = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      },
      cache: 'no-store'
    });

    if (!cartRes.ok) return null;

    const cartData = await cartRes.json();

    const cartCount = document.querySelector('[data-cart-count]');
    const cartCountText = document.querySelector('[data-cart-count-text]');

    if (cartCount) {
      cartCount.textContent = cartData.item_count;
      cartCount.classList.toggle('is-empty', cartData.item_count === 0);
    }

    if (cartCountText) {
      cartCountText.textContent = `(${cartData.item_count})`;
    }

    return cartData;
  };

  const getSectionId = () => {
    const drawer = getDrawer();
    return drawer?.dataset.sectionId || 'cart-drawer';
  };

  const refreshCart = async () => {
    try {
      const sectionId = getSectionId();

      const res = await fetch(`/?section_id=${encodeURIComponent(sectionId)}`, {
        headers: {
          Accept: 'text/html'
        },
        cache: 'no-store'
      });

      if (!res.ok) {
        throw new Error('Cart drawer section request failed');
      }

      const html = await res.text();
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      const newDrawer = tempDiv.querySelector(CART_DRAWER_SELECTOR);
      const currentDrawer = getDrawer();

      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
        cartDrawer = currentDrawer;
      }

      await updateCartHeaderCount();
    } catch (err) {
      console.error('[Cart Drawer] Refresh error:', err);
      await updateCartHeaderCount();
    }
  };

  const parseCartErrorMessage = async (response) => {
    try {
      const data = await response.json();

      return (
        data.description ||
        data.message ||
        data.errors ||
        'Sepet güncellenirken bir sorun oluştu.'
      );
    } catch {
      return 'Sepet güncellenirken bir sorun oluştu.';
    }
  };

  const updateLineQty = async (lineKey, qty) => {
    if (!lineKey || isUpdating) return;

    const safeQty = Math.max(0, parseInt(qty, 10) || 0);
    const maxQty = getMaxQtyByKey(lineKey);
    const input = findQtyInputByKey(lineKey);

    if (maxQty !== null && safeQty > maxQty) {
      if (input) input.value = maxQty;
      showStockWarning(maxQty);
      return;
    }

    isUpdating = true;
    setDrawerLoading(true);

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: safeQty
        })
      });

      if (!res.ok) {
        const message = await parseCartErrorMessage(res);
        alert(message);
        throw new Error(message);
      }

      await refreshCart();

      document.dispatchEvent(
        new CustomEvent('cart:drawer-updated', {
          detail: {
            key: lineKey,
            quantity: safeQty
          }
        })
      );
    } catch (err) {
      console.error('[Cart Drawer] Update quantity error:', err);
    } finally {
      isUpdating = false;
      setDrawerLoading(false);
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const cartToggle = event.target.closest('[data-cart-toggle]');
      if (cartToggle) {
        event.preventDefault();
        event.stopPropagation();
        openCartDrawer();
        return;
      }

      const cartClose = event.target.closest('[data-cart-close]');
      if (cartClose) {
        event.preventDefault();
        event.stopPropagation();
        closeCartDrawer();
        return;
      }

      const removeBtn = event.target.closest('[data-cart-remove]');
      if (removeBtn) {
        event.preventDefault();
        event.stopPropagation();

        const key = removeBtn.dataset.cartRemove;
        updateLineQty(key, 0);
        return;
      }

      const decreaseBtn = event.target.closest('[data-qty-decrease]');
      if (decreaseBtn) {
        event.preventDefault();
        event.stopPropagation();

        const key = decreaseBtn.dataset.qtyDecrease;
        const input = findQtyInputByKey(key);
        const currentQty = parseInt(input?.value || '0', 10) || 0;

        updateLineQty(key, Math.max(0, currentQty - 1));
        return;
      }

      const increaseBtn = event.target.closest('[data-qty-increase]');
      if (increaseBtn) {
        event.preventDefault();
        event.stopPropagation();

        const key = increaseBtn.dataset.qtyIncrease;
        const input = findQtyInputByKey(key);
        const currentQty = parseInt(input?.value || '0', 10) || 0;
        const nextQty = currentQty + 1;
        const maxQty = getMaxQtyByKey(key);

        if (maxQty !== null && nextQty > maxQty) {
          if (input) input.value = maxQty;
          showStockWarning(maxQty);
          return;
        }

        updateLineQty(key, nextQty);
      }
    },
    true
  );

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-qty-input]');
    const drawer = getDrawer();

    if (!input || !drawer || !drawer.contains(input)) return;

    clearTimeout(qtyInputTimer);

    qtyInputTimer = setTimeout(() => {
      const key = input.dataset.qtyInput;
      const requestedQty = Math.max(0, parseInt(input.value || '0', 10) || 0);
      const maxQty = getMaxQtyByKey(key);

      if (maxQty !== null && requestedQty > maxQty) {
        input.value = maxQty;
        showStockWarning(maxQty);
        return;
      }

      updateLineQty(key, requestedQty);
    }, 250);
  });

  overlay?.addEventListener('click', () => {
    if (document.body.classList.contains('cart-open')) {
      closeCartDrawer();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && document.body.classList.contains('cart-open')) {
      closeCartDrawer();
    }
  });

  document.addEventListener('cart:add', async () => {
    await refreshCart();
    openCartDrawer();
  });

  document.addEventListener('cart:updated', refreshCart);

  window.addEventListener('resize', setScrollbarWidth);

  console.log('[Cart Drawer] Event handlers attached');
})();